"use client";

import { cn } from "@/lib/utils";
import { type ReactNode } from "react";

interface HolographicTextProps {
  children: ReactNode;
  as?: "h1" | "h2" | "h3" | "h4" | "span" | "p";
  className?: string;
  animate?: boolean;
}

export function HolographicText({
  children,
  as: Tag = "span",
  className,
  animate = true,
}: HolographicTextProps) {
  return (
    <Tag
      className={cn(
        "bg-clip-text text-transparent font-[family-name:var(--font-space-grotesk)] font-bold",
        "bg-gradient-to-r from-neon-cyan via-neon-pink to-neon-purple bg-[length:200%_auto]",
        animate && "animate-[holographic_4s_ease_infinite]",
        className,
      )}
    >
      {children}
    </Tag>
  );
}
